import React from 'react';

import FingerprintJS from '@fingerprintjs/fingerprintjs';
import CryptoJS from 'crypto-js';
import aes from 'crypto-js/aes';

import usePersistedState from '../utility/use-persisted-state';
import { Loading } from './index';

type Props = {
    sha512: string;
    renderSignIn: (handleSubmit: (value: string) => boolean) => React.ReactNode;
    children: React.ReactNode;
};

const Protect = ({ sha512, renderSignIn, children }: Props) => {
    const chkHash = sha512.toLowerCase();
    const [fp, setFP] = React.useState(null);
    const [decryptedHash, setDecryptedHash] = React.useState('');

    const [cipher, setCipher] = usePersistedState('cipher', '');
    const context = React.useMemo(() => ({ cipher, setCipher }), [cipher, setCipher]);

    const submitPassword = (password: string): boolean => {
        const hash = CryptoJS.SHA512(password).toString();

        const isCorrectPassword = hash === chkHash;
        if (isCorrectPassword) {
            setCipher(aes.encrypt(JSON.stringify({ password }), fp.visitorId).toString());
            setDecryptedHash(hash);
        } else {
            setCipher('');
        }

        return isCorrectPassword;
    };

    React.useEffect(() => {
        (async function getFingerprint() {
            const fpi = await FingerprintJS.load();
            const result = await fpi.get();
            let d;
            try {
                d = aes.decrypt(cipher, result.visitorId).toString(CryptoJS.enc.Utf8);
            } catch (e) {
                d = '';
            }

            if (d) {
                const hash = CryptoJS.SHA512(JSON.parse(d).password).toString();
                setDecryptedHash(hash);
            }

            setFP(result);
        })();
    }, []);

    if (fp !== null && decryptedHash === chkHash) {
        return children;
    }

    return (
        <>
            {fp === null && <Loading />}
            {fp !== null &&
                decryptedHash !== chkHash &&
                renderSignIn &&
                renderSignIn(submitPassword)}
        </>
    );
};

export default Protect;
